<template>
    <v-form-item
        name="replyImg"
        label="图片消息"
        required="请选择"
        :rules="rules"
        @error="handlerError"
    >
        <v-input
            :value="currentValue.url"
            name="replyImg"
            style="display: none;"
        />
        <div class="flex">
            <div
                @click="chooseImg"
                class="flex"
            >
                <template v-if="currentValue.url">
                    <div
                        :style="`background-image: url(${currentValue.imgurl});`"
                        class="img-preview"
                    />
                    <v-button
                        type="link"
                        kind="primary"
                    >
                        修改
                    </v-button>
                </template>

                <div
                    v-else
                    class="img-picker"
                >
                    <span>请选择</span>
                </div>
            </div>
        </div>
        <img-select-panel
            :show="isShowImgSelectPanel"
            :picker="currentValue"
            @handler-ok="handlerOk"
            @handler-cancel="isShowImgSelectPanel = false"
        />
    </v-form-item>
</template>

<script>
import ImgSelectPanel from '@/components/img-select-panel/index';
import errorMixin from '../errorMixin';

export default {
    mixins: [errorMixin],
    components: {
        ImgSelectPanel,
    },
    props: {
        value: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            currentValue: this.value || {},
            isShowImgSelectPanel: false,
            rules: [{
                validate: (val, rule) => {
                    return this.$ajax.get(`/mp/rest/imgMaterial/${this.currentValue.materialId}`)
                        .then((res) => {
                            if (res.id === -1) {
                                throw new Error(rule.message);
                            }

                            return true
                        });
                },
                message: '素材已被删除，请重新选择',
                trigger: 'input,submit',
            }],
        };
    },
    computed: {

    },
    watch: {
        value(val) {
            this.currentValue = val;
        },
        currentValue(val) {
            this.$emit('input', val);
        },
    },

    methods: {
        chooseImg() {
            this.isShowImgSelectPanel = true;
        },

        handlerOk(data) {
            this.isShowImgSelectPanel = false;
            this.currentValue = data;
        },
    },
};
</script>

<style lang="less" scoped>
.flex{
    display: flex;
    align-items: center;
}
.img-preview,
.img-picker{
    width: 88px;
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: var(--color-text-caption);
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-radius: var(--radius-normal);
    cursor: pointer;
}
.img-picker{
    border: 1px dashed var(--color-border-normal);
}
.img-preview{
    margin-right: 10px;
}
</style>
